module.exports = __webpack_public_path__ + "img/icon4.9812920d.svg";